'use client';

import { useEffect, useState } from 'react';
import { getFootprints } from '@/lib/actions/footprints';
import { FootprintList } from '@/components/admin/footprints/FootprintList';

export default function AdminFootprintsPage() {
  const [footprints, setFootprints] = useState<Awaited<ReturnType<typeof getFootprints>>>([]);

  useEffect(() => {
    getFootprints().then(setFootprints);
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-navy">Footprints / Industry</h1>
      </div>

      <FootprintList footprints={footprints} />
    </div>
  );
}
